/**
 * Zielony „Akceptuj w CEEB" na liście budynków — czysta reguła widoczności (PipelineView: przycisk w wierszu i zaznaczenie
 * do akceptacji zbiorczej). Serwer i tak sprawdza wszystko jeszcze raz (`acceptGateError` w backend/src/routes/ceebPushQuery.js).
 *
 * 2026-10-21 (Harcerska 9, 441967/2026): protokół zaakceptowany RĘCZNIE w CEEB, a przegląd u nas wciąż „Wprowadzony".
 * Lustro CEEB (`ceebMirrorStatus`, nocny import) mówi „Zaakceptowany" → akceptować nie ma czego (w CEEB nie ma już
 * pozycji „Akceptuj"). Backend od tej zmiany sam podnosi `ceebStatus` do „Zaakceptowany"; warunek na lustrze tu
 * zostaje jako pas bezpieczeństwa.
 */
import type { PipelineBuilding } from '../services/api';

type AcceptRow = Pick<PipelineBuilding, 'ceebStatus' | 'ceebAcceptedAt' | 'ceebCaseNumber' | 'ceebMirrorStatus'>;

/** Czeka na zielony „Akceptuj" (stan + numer sprawy, jak serwer) — niezależnie od bramki lokali. */
export function awaitsAcceptance(b: AcceptRow): boolean {
  return b.ceebStatus === 'Wprowadzony' && !b.ceebAcceptedAt && !!b.ceebCaseNumber
    && b.ceebMirrorStatus !== 'Zaakceptowany';
}
